// context/FlowContext/flowReducer.js
export const initialState = {
    isLocked: false,
    panMode: 'scrollPan',
    undoHistory: [],
    undoPosition: -1,
    showAllModuleOverlays: false
  };
  
  export const ActionTypes = {
    SET_LOCKED: 'SET_LOCKED',
    SET_PAN_MODE: 'SET_PAN_MODE',
    ADD_HISTORY_EVENT: 'ADD_HISTORY_EVENT',
    UNDO: 'UNDO',
    REDO: 'REDO',
    UPDATE_UNDO_HISTORY: 'UPDATE_UNDO_HISTORY',
    SET_SHOW_ALL_MODULE_OVERLAYS: 'SET_SHOW_ALL_MODULE_OVERLAYS',
  };  
  
  export const flowReducer = (state, action) => {
    switch (action.type) {
      case ActionTypes.SET_LOCKED:
        return {
          ...state,
          isLocked: action.payload
        };

      case ActionTypes.SET_PAN_MODE:
        return {
          ...state,
          panMode: action.payload
        };

      case ActionTypes.ADD_HISTORY_EVENT: {
        const newHistory = state.undoPosition < state.undoHistory.length - 1
          ? state.undoHistory.slice(0, state.undoPosition + 1)
          : state.undoHistory;
        
        return {
          ...state,
          undoHistory: [...newHistory, action.payload].slice(-20),
          undoPosition: Math.min(newHistory.length, 19)
        };
      }

      case ActionTypes.UNDO:
        return {
          ...state,
          undoPosition: Math.max(-1, state.undoPosition - 1)
        };

      case ActionTypes.REDO:
        return {
          ...state,
          undoPosition: Math.min(state.undoHistory.length - 1, state.undoPosition + 1)
        };

      case ActionTypes.UPDATE_UNDO_HISTORY: // Add new action case
        return {
          ...state,
          undoHistory: action.payload.undoHistory,
          undoPosition: action.payload.undoPosition,
        };

      case ActionTypes.SET_SHOW_ALL_MODULE_OVERLAYS:
        return {
          ...state,
          showAllModuleOverlays: action.payload
        };
        
      default:
        return state;
    }
  };